function convertSquareFootToAcre(num) {
  let eq =
    "Converting " + num + " square foot to acre: \n" + num + " * 0.00002295684114 = ";
  let rep = num * 0.00002295684114 ;
  return eq + rep.toFixed(6);
}

function convertSquareFootToHectare(num) {
  let eq =
    "Converting " +
    num +
    " square foot to hectare: \n" +
    num +
    " * 0.000009290304 = ";
  let rep = num * 0.000009290304 ;
  return eq + rep.toFixed(6);
}

function convertSquareFootToSquareInch(num) {
  let eq =
    "Converting " +
    num +
    " square foot to square inch: \n" +
    num +
    " * 144 = ";
  let rep = num * 144;
  return eq + rep.toFixed(2);
}

function convertSquareFootToSquareMeter(num) {
  let eq =
    "Converting " +
    num +
    " square foot to square meter: \n" +
    num +
    " * 0.09290304 = ";
  let rep = num * 0.09290304;
  return eq + rep.toFixed(4);
}

function convertSquareFootToSquareMile(num) {
  let eq =
    "Converting " +
    num +
    " square foot to square mile: \n" +
    num +
    " * 3.587006428e-8 = ";
  let rep = num * 3.587006428e-8;
  return eq + rep.toFixed(9);
}

function convertSquareFootToSquareYard(num) {
  let eq =
    "Converting " +
    num +
    " square foot to square yard: \n" +
    num +
    " * 0.1111111111 = ";
  let rep = num * 0.1111111111;
  return eq + rep.toFixed(3);
}

export {
  convertSquareFootToAcre,
  convertSquareFootToHectare,
  convertSquareFootToSquareInch,
  convertSquareFootToSquareMeter,
  convertSquareFootToSquareMile,
  convertSquareFootToSquareYard
};
